// extracted by mini-css-extract-plugin
export default {"buttonContainer":"_07sEx","alignToEdge":"IF-zA","buttonIcon":"_53BWS","buttonCaption":"YZ-Ss","buttonSpacer":"ykboe"};